namespace Gordic.Adm.WebControls {
    export abstract class GAdmHromadnaOperaceBase<TDto> {
        options: IGAdmHromadnaOperaceOptions;
        cnt: GContent & GAdmHromadnaOperaceBase<TDto>;
        formData: any;
        defineGridData: any[];
        resultGridData: any[];
        gridFormatBase: Gordic.Data.GridFormat;
        selectedData: any[];
        serviceCnt: GContent;
        closeOnSuccess: boolean;
        hromadneZmenyFields: { fieldName: string, caption: string, items: string[] }[]
        form: Gordic.Forms.Form;

        grid: JQuery<HTMLElement>;
        
        gridResult: JQuery<HTMLElement>;
        wizard: JQuery<HTMLElement>;

        abstract createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange): void;

        abstract createDefineGridData(formData: any): any[];

        abstract createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat;

        abstract saveData(data: any[]): JQueryPromise<any>;

        abstract validateRows(data: any): Gordic.Validators.GridError[];

        abstract testExistMethod(data: any[]): JQueryPromise<any>;

        createBase(this: GContent & GAdmHromadnaOperaceBase<TDto>, options: IGAdmHromadnaOperaceOptions) {
            this.closeOnSuccess = false;
            this.cnt = this;
            this.options = { ...OptionsHromadnaOperaceDefaults, ...options };
            this.options.formSettings = { ...OptionsHromadnaOperaceDefaults.formSettings, ...options.formSettings }
            this.hromadneZmenyFields = [];
            if (this.options.formSettings.aktivitaField == true) 
                this.hromadneZmenyFields.push({ fieldName: "aktivita", caption: "jres:32131030", items: ["aktivita", "aktivita_txt"] })
            if (this.options.formSettings.datOdDoField == true) {
                this.hromadneZmenyFields.push({ fieldName: "dat_od", caption: "jres:32131055", items: ["dat_od"] })
                this.hromadneZmenyFields.push({ fieldName: "dat_do", caption: "jres:32131056", items: ["dat_do"] })
            }
            this.options.hromadneZmenyFields?.forEach((item) => {
                this.hromadneZmenyFields.push(item);
            })
            this.createActions();
            this.cnt.uid = this.options.contentId;
            this.cnt.taskId = this.options.contentId;
            this.createWizard();
        }

        getServiceCnt(): GContent {
            if (this.serviceCnt == null || this.serviceCnt == undefined)
                this.serviceCnt = this.cnt.createServiceContent(this.options.serviceCnt);
            return this.serviceCnt;
        }

        createObjectSelectBox(form: Gordic.Forms.Form): Gordic.Forms.Form {
            var selectData: { objekt_nazev: string | null | undefined, sxs: string | null | undefined }[] = [];
            this.options.data.forEach((item) => {
                selectData.push({ objekt_nazev: item.nazev, sxs: item.sxs })
            })

            form.addRow("jres:33000493").addField("gselectbox", {
                model: "model.sxs<=value.sxs,model.objekt_nazev<=value.objekt_nazev",
                name: "data",
                data: selectData,
                initialValue: selectData,
                itemWidth: "",
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
                itemTemplate: "{objekt_nazev}",
                multi: true
            })
            return form;
        }

        // Aktivita column
        createAktivitaColumn(gridFormat: Gordic.Data.GridFormat) {
            gridFormat.addIconColumn({
                name: "aktivita",
                caption: "jres:32131030",
                iconTemplate: (row) => {
                    var text = "";
                    var icon = "";
                    switch (row.aktivita) {
                        case 100:
                            text = "jres:33000139";
                            icon = "fa-check-circle g-state-text g-state-success"
                            break;
                        case 300:
                            text = "jres:33000142"; //RC 33000142 : Připraven
                            icon = "fa-exclamation-triangle g-state-text g-state-info";
                            break;
                        case 500:
                            text = "jres:33000140";
                            icon = "fa-exclamation-triangle g-state-text g-state-warning";
                            break;
                        case 600:
                            text = "jres:33000141" //RC 33000141 : Návrh
                            icon = "fa-exclamation-triangle g-state-text g-state-info";
                            break;
                        default:
                            text = "jres:33000143" //RC 33000143 : Zrušen
                            icon = "fa-times-circle g-state-text g-state-error"
                            break;
                    }
                    return { icon: icon, text: text, tooltip: text };
                }
            })
        }

        createGridBeforeSave(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var columns = this.getColumnsDefineData()
            this.grid = $("<div>").appendTo(contentDiv).gautofit({ resizersOnTab: false }).ggrid({
                multi: true,
                columns: columns,
                columnMode: "full",
                dataKey: this.options.keys,
                contextMenu: this.cnt.actions.createBar(["actCopyRowData*"]),
                multiMenu: (this.options.updateExist == true && this.options.editMode == false) ? this.cnt.actions.createBar(["actSelectExistInDb*", "actSelectExistNotInDb*"]) : []
            })
            if (columns.filter((item) => (item.editor != null && item.editor != undefined)).length > 0) {
                this.grid.ggridroweditor({
                    save: (data, info) => {
                        if ("dat_od" in data && "dat_do" in data) {
                            const datOd = data["dat_od"];
                            const datDo = data["dat_do"];
                            if (datOd >= datDo)
                                return null;
                        }
                    },
                    commit: (data, info) => {
                        var view = $(data.target).ggrid("getView");
                        view.updateData(info.cellInfo.meta, "update");
                        this.defineGridData = view.getDataRows(false, "data");
                        $(data.target).ggrid("setData", view);
                    }
                })
                var viewFlash = this.cnt.userSettings?.getDef("viewEditInfoMessage", true);
                if (viewFlash == true) {
                    var iconPencil = new Gordic.Utils.IconBuilder().createIcon("fa-pencil");
                    this.cnt.showFlash({
                        content: "jres:33001051".format(iconPencil), //RC 33001051 : Hodnoty ve sloupcích lze upravit přímo v seznamu přes tlačítko {0} nebo dvojklikem na vybraný řádek.
                        state: "info",
                        id: "edit-grid-info",
                        close: (ev, ctx) => {
                            this.cnt.userSettings?.set("viewEditInfoMessage", false);
                        }
                    })
                }
            }
            if (this.options.editMode == true)
                this.defineGridData = this.options.data;
            let dataToGrid = this.defineGridData;
            //dataToGrid.forEach((item) => { item.isChecked = true })
            if (this.options.updateExist == true && this.options.editMode == false) {
                let pkKeys = this.mapPrimaryKey(dataToGrid);
                this.testExistMethod(pkKeys).then((existResult: any[]) => {
                    let stringify = pkKeys.map((item) => JSON.stringify(item));
                    existResult.forEach((item) => {
                        let index = -1;
                        do {
                            index = stringify.indexOf(JSON.stringify(item.data), index + 1)
                            if (index != -1)
                                dataToGrid[index].exist = item.result 
                        } while (index != -1)
                    })
                    this.grid.ggrid("setData", this.createView(dataToGrid));
                })
            } else {
                this.grid.ggrid("setData", this.createView(dataToGrid));
            }
        }

        private mapPrimaryKey(data: any[]): any[] {
            return data.map((item) => {
                let itemDto = {};
                this.options.keys.forEach(key => { itemDto[key] = item[key] })
                return itemDto;
            })
        }

        private createView(data: any[]): Gordic.Data.View {
            var view: Gordic.Data.View = new Gordic.Data.View(data, { key: this.options.keys });
            var captions: string[] = this.getGroupColumnCaption();
            if (this.options.objectFields.length > 0) {
                view.process({
                    ac: new Gordic.Data.Grouping([{
                        defaultState: "open",
                        hash: (meta, rows) => {
                            return `<span style='font-weight: 100'>${captions[0]}:</span> ${meta.data[this.options.objectFields[0]]}`;
                        }
                    }]),
                })
            }
            view.getDataRows(true).forEach((meta) => {
                meta.checked = true;
            })
            return view;
        }

        // Úprava dat kartézský součin
        createCartesianProduct2D(array1, array2): any[] {
            const data = [array1, array2];
            return data.reduce((a, b) => a.flatMap((x) => b.map((y) => [...x, y])), [[]])
        }

        transformDataToArrayObject(formData: any[], propertyName: string[]): any[] {
            var arrayObjekt: any = [];
            if (formData[propertyName[0]]) {
                for (var i = 0; i < formData[propertyName[0]].length; i++) {
                    var data: any = {};
                    propertyName.forEach((item) => {
                        data[item] = formData[item][i]
                    })
                    arrayObjekt.push(data);
                }
            }
            return arrayObjekt;
        } 

        getColumnsDefineData(): GGridColumn<any>[] {
            this.gridFormatBase = this.createGridFormatBase(false);
            var columns = this.gridFormatBase.columns;
            this.options.objectFields.forEach((item) => {
                columns = columns.filter((obj) => { return obj.name != item })
            })
            return columns;
        }

        getGroupColumnCaption(): string[] {
            var captions: string[] = [];
            var columnCaption: string | undefined = "";
            this.options.objectFields.forEach((item) => {
                columnCaption = this.gridFormatBase.columns.filter((obj) => { return obj.name == item })[0].caption;
                if (columnCaption != undefined)
                    captions.push(columnCaption);
                else 
                    captions.push("");
            })
            return captions;
        }

        getColumnsResultData(): GGridColumn<any>[] {
            var gridFormat = new Gordic.Data.GridFormat().addIconColumn({
                name: "message",
                caption: "jres:33000028",
                formatPreset: "full",
                iconTemplate: (row, meta) => {
                    if (row.resultId == 1)
                        return { icon: "fa-times-circle g-state-text g-state-error", text: row.message }
                    return { icon: "fa-check-circle g-state-text g-state-success", text: "jres:33000243" }
                }
            }).addNumberColumn({
                name: "resultId",
                visible: false,
                hidden: true
            })
            gridFormat.add(this.createGridFormatBase(true).columns)
            return gridFormat.columns;
        }

        createGridFormatBase(resultGrid: boolean = false): Gordic.Data.GridFormat {
            var gridFormat = new Gordic.Data.GridFormat();
            if (this.options.updateExist == true && this.options.editMode == false) {
                if (resultGrid == false) {
                    gridFormat.addIconColumn({
                        name: "exist",
                        caption: "jres:33000980", //RC 33000980 : Existence záznamu
                        iconTemplate: (row, meta) => {
                            if (row.exist == true)
                                return { icon: "fa-exclamation-triangle g-state-text g-state-warning", text: "jres:33000981" } //RC 33000981 : Záznam již existuje, při uložení bude aktualizován.
                            return null;
                        }
                    })
                }
            }
            return this.createGridFormat(gridFormat);
        }

        createResultData(resultData: {data: any, message: string, result: number}[]) {
            this.resultGridData = [];
            resultData.forEach((item) => {
                var result = this.defineGridData.find(obj => {
                    var defineObj: any = {};
                    var itemObj: any = {};
                    this.options.keys.forEach((key) => {
                        defineObj[key] = (obj[key] != null && obj[key] != undefined) ? (typeof (obj[key]) == "string" ? obj[key].trim() : obj[key] ): "";
                        itemObj[key] = (item["data"][key] != null && item["data"][key] != undefined) ? (typeof (item["data"][key]) == "string" ? item["data"][key].trim() : item["data"][key]) : "";
                    })
                    return JSON.stringify(defineObj) == JSON.stringify(itemObj); 
                })
                if (result != null && result != undefined) {
                    result["resultId"] = item.result;
                    result["result"] = (item.result == 1) ? "jres:32000124" : "jres:33000243";
                    result["message"] = item.message;
                    this.resultGridData.push(result);
                }
            })
        }

        createResultGrid(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            this.closeOnSuccess = true;
            var view: Gordic.Data.View = new Gordic.Data.View(this.resultGridData, { key: this.options.keys });
            view.process({
                ac: new Gordic.Data.Grouping([{
                    defaultState: "open",
                    hash: (meta, rows) => {
                        return `${meta.data['result']}`;
                    }
                }]),
            })
            this.gridResult = $("<div>").appendTo(contentDiv).gautofit({ resizersOnTab: false }).ggrid({
                columns: this.getColumnsResultData(),
                data: view,
                columnMode: "full",
                emptyMessage: "<i>jres:33000498</i>", //RC 33000498 : Nebyla vybrána žádná data k uložení!
            })
        }

        getActionAdd(typ_obj: number): MenuParams {
            return {
                actionContext: { add: true, typ_obj: typ_obj },
                action: this.cnt.actions.actGetDataFromVyberovaSkupina
            }
        }

        createDefaultFields(form: Gordic.Forms.Form): Gordic.Forms.Form {
            if (this.options.formSettings?.aktivitaField == true) {
                form.addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                    initialValue: { aktivita: 100 },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    dropdown: true
                }) 
            }
            if (this.options.formSettings?.datOdDoField == true) {
                var date = new Date();
                form.addRow("jres:32131097").addField("gdatebox", {
                    name: "dat_od",
                    initialValue: new Date(),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                }).addRow("jres:32131098").addField("gdatebox", {
                    name: "dat_do",
                    initialValue: new Date(date.getFullYear() + 100, date.getMonth(), date.getDate()),
                    validators: [new Gordic.Validators.Required({ stopping: true }), this.createSpecialOdDoValidator()],
                    flag: "required"
                })
            }
            //if (this.options.formSettings?.updateExistField == true) {
            //    form.addRow().addField("gcheck", {
            //        name: "update_exist",
            //        label: "jres:33000963" //RC 33000963 : Pokud záznam existuje, aktualizovat ho podle nových hodnot.
            //    })
            //}
            return form;
        }

        createSpecialOdDoValidator(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33000718", //RC 33000718 : Data od a do nejsou správně nastavena.
                validate: (val, ev) => {
                    var cnt = $.content($(ev))
                    var datOd = cnt.findFields("dat_od").gfield("getValue");
                    var datDo = cnt.findFields("dat_do").gfield("getValue");
                    if (datOd && datDo) {
                        if (datOd <= datDo)
                            return true;
                        return false;
                    }
                    return false;
                }
            })
        }

        getCurrentDate(): Date {
            return new Date();
        }

        getCurrentDate100Years(): Date {
            var currentData = this.getCurrentDate();
            return new Date(currentData.getFullYear() + 100, currentData.getMonth(), currentData.getDate());
        }

        private createActions() {
            this.cnt.actions.addRange({
                actCopyRowData: {
                    caption: "jres:33000966", //RC 33000966 : Kopírovat data z označeného řádku
                    tooltip: (this.options.editMode == true) ? "jres:33000968" : "jres:33000969", //RC 33000969 : Rozkopíruje vybraná data na další vytvářené objekty
                    icon: "gi-copy",
                    run: (ev, ctx) => {
                        this.copyRowData();
                    }
                },
                actGetDataFromVyberovaSkupina: {
                    run: (ev, ctx) => {
                        //Gordic.Adm.WebControls.GAdmGlobals.VyberovaSkupinaDialog()
                    }
                },
                actSelectExistInDb: {
                    caption: "jres:33000982", //RC 33000982 : Vybrat existující
                    run: (ev, ctx) => {
                        this.selectExistInDb(ctx, true);
                    }
                },
                actSelectExistNotInDb: {
                    caption: "jres:33000983", //RC 33000983 : Vybrat neexistující
                    run: (ev, ctx) => {
                        this.selectExistInDb(ctx, false);
                    }
                }
            })
        }

        // Základní vytvoření Wizard
        private createWizard() {
            var steps: IGWizardStepsType[] = [];
            if (this.options.editMode == false) {
                steps.push({
                    caption: "jres:33000494", //RC 33000494 : Definice dat
                    create: (cnt, contentDiv, change) => {
                        change.stepsEnable = [true, false, false];
                        this.form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" });
                        this.createForm(cnt, contentDiv, change);
                    },
                    change: (cnt, contentDiv, change) => {
                        change.stepsEnable = [false, true, false];
                        var that = this;
                        this.defineGridData = [];
                        return $.Deferred(function () {
                            var def = this;
                            if (contentDiv.findForms().gform("isValid") == true) {
                                that.formData = {};
                                contentDiv.findForms().findFields().gfield("model", "collect", that.formData);
                                that.defineGridData = that.createDefineGridData(that.formData);
                                return that.updateDataBeforeEditGrid().done(() => {
                                    def.resolve();
                                }).catch(() => {
                                    def.reject()
                                })
                            } else
                                def.reject();
                        })

                    }
                })
            }
            steps.push({
                caption: (this.options.editMode) ? "jres:33000964" : "jres:33000495", //RC 33000964 : Upravovaná data
                create: (cnt, contentDiv, change) => {
                    change.stepsEnable = (this.options.editMode == false) ? [false, true, false] : [true, false];
                    this.createGridBeforeSave(cnt, contentDiv, change);
                },
                change: (cnt, contentDiv, change) => {
                    change.stepsEnable = (this.options.editMode == false) ? [false, false, true] : [false, true];
                    return this.getDataBeforeSave(cnt);
                }
            })
            steps.push({
                caption: "jres:33000028",
                create: (cnt, contentDiv, change) => {
                    change.stepsEnable = (this.options.editMode == false) ? [false, true, true] : [true, true];
                    this.createResultGrid(cnt, contentDiv, change)
                },
                change: (cnt, contentDiv, change) => {

                }
            })


            new Gordic.Wizard().create({
                content: this.cnt
            }, {
                title: this.options.title,
                complete: (cnt, contentDiv, change) => {
                    cnt.close();
                },
                steps: steps
            })
        }

        private getDataBeforeSave(cnt: GContent): JQueryPromise<any> {
            this.selectedData = this.grid.ggrid("getSelection", false, false);
            var view = this.grid.ggrid("getView")
            view.process({
                error: new Gordic.Data.ErrorProcessor((datarow, metarow) => {
                    let errors: Gordic.Validators.GridError[] = [];
                    if (this.options.formSettings?.datOdDoField == true) {
                        if (new Date(datarow["dat_od"]) >= new Date(datarow["dat_do"])) {
                            errors.push(this.createError("jres:33000551"))
                        }
                    }
                    errors = errors.concat(this.validateRows(datarow));
                    return errors;
                })
            })
            if (this.grid.ggrid("getErrors").length != 0)
                return $.Deferred(function () {
                    var def = this; return def.reject
                })
            this.cnt.hideFlash("edit-grid-info");
            return this.saveData(this.selectedData);
        }

        getAllAktivita(): number[] {
            return [100, 300, 500, 600, 900]
        }

        private copyRowData() {
            if (this.grid) {
                let form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1, L-0-12-0, M-0-12-0, S-0-12-0" })
                this.hromadneZmenyFields?.forEach((item) => {
                    form.addRow().addField("gcheck", {
                        name: item.fieldName,
                        label: item.caption,
                    })
                })
                let minHeight = this.hromadneZmenyFields.length * 50;
                this.cnt.dialogs.simpleForm("jres:33000967", form, null, { //RC 33000967 : Vyberte sloupce ke kopírování
                    width: 300,
                    height: minHeight > 300 ? minHeight : 310,
                }).on("ok", (ev, data) => {
                    let activeRow = this.grid.ggrid("activeRow");
                    let viewData = this.grid.ggrid("getView");
                    let gridData = viewData.getDataRows(false, "data");
                    Object.keys(data).forEach((item) => {
                        if (data[item] == true) {
                            let data = this.hromadneZmenyFields.filter(obj => obj.fieldName == item)
                            if (data.length > 0) {
                                data[0].items.forEach((dataItem) => {
                                    gridData.forEach((gridItem) => {
                                        gridItem[dataItem] = activeRow[dataItem]
                                    })
                                })
                            }
                        }
                    })
                    this.grid.ggrid("setData", this.createView(gridData));
                })
            }
        }

        createError(message: string, errorType: string = "error"): Gordic.Validators.GridError {
            return {
                group: "grid-error",
                message: message,
                errorType: errorType
            }
        }

        transformBoolValue(yesValue: number = 1): {
            apply?(modelValue: any): any | null | undefined | void;
            collect?(fieldValue: null | any): any | null | undefined | void;
        } {
            return {
                apply: function (modelValue) { return modelValue === yesValue; },
                collect: function (fieldValue) { return fieldValue === true ? yesValue : 0; }
            }
        }

        selectExistInDb(ctx: any, exist: boolean) {
            this.grid.ggrid("getView").getDataRows(true).forEach((meta) => {
                meta.checked = meta.data.exist == exist;
            });
            this.grid.ggrid("refreshRows")
        }

        createFlagNemenne(): GFieldFlagOptions {
            return { text: "jres:32131150", state: "important" }
        }

        updateDataBeforeEditGrid(): JQueryPromise<any> {
            return $.Deferred(function () {
                var def = this;
                return def.resolve();
            })
        }
    }
}